module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/info_image@1x.6f930c0.png";